module.exports = __webpack_public_path__ + "static/media/coding.d1d7ed02.gif";